import axios from 'axios';
import stringify from 'qs-stringify';

const apiAxios = axios.create();
const anyAxios = axios.create();

apiAxios.defaults.paramsSerializer = stringify;

export { apiAxios, anyAxios };
